export default "__VITE_ASSET__CxKoKJlm__"